import { Behavior } from '@dia-ui/abstract';
// @ts-ignore
import Guides from "@scena/guides";

@Behavior('ruler')
export class Ruler {
  element: any;

  // This is called only once, given the `element` that the behavior is attached to.
  constructor(element) {
    this.element = element;
  }

  // This is called any time the associated `element` is appended into the
  // DOM, passed in the `element`
  async connectedCallback(){
    this.init();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "data-ruler-scale") {
          this.element.firstElementChild.remove();

          this.init();
        }
      });
    });

    observer.observe(this.element, { attributes: true });
  }

  /**
   * init
   */
  init() {
    let type = this.element.getAttribute("data-ruler-type") || "horizontal",
        scale = Number.parseFloat(this.element.getAttribute("data-ruler-scale")) || 0.75;

    new Guides(this.element, {
      type: type,
      zoom: (37.7952 * scale),
      unit: 1,
      displayDragPos: true,
      backgroundColor: "#fff",
      textColor: "#222",
      rulerStyle: type === "horizontal" ? {
        left: "30px",
        width: "calc(100% - 30px)",
        height: "100%"
      } : {
        top: "30px",
        height: "calc(100% - 30px)",
        width: "100%"
      },
      useResizeObserver: true,
    });
  }

  // This is called any time the associated `element` is removed from the DOM,
  // passed in the `element`.
  disconnectedCallback() {
  }

  // As with custom elements, define which attributes of the associated
  // element that the behavior should react to.
  /*static observedAttributes = [
    'data-draggable-events',
    'data-draggable-selector'
  ];*/

  // This is called any time any of the `observedAttributes` of the associated
  // element have been changed, just like with Custom Elements but with the
  // additional passed in `element`.
  // attributeChangedCallback(attributeName, oldValue, newValue, element) {}

  // There is one additional API, unlike with Custom Elements. If `static
  // awaitElementDefined` is `true`, then the behavior will not be
  // instantiated and connected until its host element is defined and upgraded
  // (that is, if the host element is possibly a custom element, having a
  // hyphen in its name). If the host element has no hyphen in its name, then
  // this does not apply, and the behavior will be created and connected
  // immediately without waiting. If a possibly-custom element is removed
  // before it is defined, then a behavior will not be created and connected
  // at all (waiting will have been canceled).
  static awaitElementDefined = true // Default is false.
}
